import React, { useEffect, useState } from 'react';

const OfflineBanner = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);


    const handleOnline = () => {
        setIsOnline(true);
    };

    const handleOffline = () => {
        setIsOnline(false);
    };

  return (
    <>
        {!isOnline && (
    <div className="mt-16 h-20 bg-violet-500/5">
            <div className="flex items-center justify-center h-full text-violet-500/80">
                <p className="text-xl tracking-wide">You are currently offline. Some features may not work as expected.</p>
            </div>
            </div>
        )}
      </>
  );
};

export default OfflineBanner;
